import { type ClassValue, clsx } from "clsx";
import { twMerge } from "tailwind-merge";

// shadcn's class-name composer — file lives at src/lib/utils.ts because
// shadcn's components.json points its `utils` alias at @/lib/utils.
// Other small cross-cutting helpers (sleep, formatters, …) get added
// here so the app has one place to look for utilities.
export function cn(...inputs: ClassValue[]) {
	return twMerge(clsx(inputs));
}

// Awaitable delay. Used by mock api implementations to add realistic
// latency so loading-state UX stays honest during dev.
export const sleep = (ms: number): Promise<void> =>
	new Promise((resolve) => setTimeout(resolve, ms));
